
import { useQuery } from '@tanstack/react-query';
import { STYLE_FILTERS, StyleFilterData } from '../data/style-filters';

/**
 * Hook to fetch style prompts from static data with category filtering
 */
export const useStaticStylePrompts = (imageType: string | null) => {
  return useQuery({
    queryKey: ['static-style-prompts', imageType],
    enabled: !!imageType,
    queryFn: async (): Promise<StyleFilterData[]> => {
      if (!imageType) return [];
      
      // Simulate async behavior to maintain interface compatibility
      await new Promise(resolve => setTimeout(resolve, 1));
      
      return STYLE_FILTERS
        .filter(style => style.category.toLowerCase() === imageType.toLowerCase())
        .sort((a, b) => b.priority - a.priority);
    },
    staleTime: Infinity, // Static data never goes stale
    gcTime: Infinity, // Keep in cache forever
  });
};
